import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Routes from './routes/Routes';
import ReduxSuspense from './components/ReduxSuspense/ReduxSuspense';
import SeoContainer from './components/SeoContainer/SeoContainer';
import Footer from './components/Footer/Footer';
import OneTrust from './components/OneTrust/OneTrust';

import { Matomo } from './components/Tracking/Matomo';
import ScrollToTop from './components/ScrollToTop';
import Theme from './components/themes';
import FloatingSidebar from './components/FloatingSidebar/FloatingSidebar';
import ToTop from './components/FloatingSidebar/ToTop';
import { sessionIdSelector } from '../modules/selectors/auth';
import { setNewSessionId } from '../modules/actions/auth/sessionId';
import HeadMeta from './components/Head/HeadMeta';
import HeaderSelector from './components/Header/HeaderSelector';
import { NoSSR } from '../helpers/SSRHelper';
import { useLocation } from 'react-router';
import Anchor from './components/form-elements/Anchor';
import useRedirectCheck from '../helpers/getRiderectsHelper';

function Layout({ markenStandortResponse, seoMetaDataResponse }) {
    const dispatch = useDispatch();
    const sessionId = useSelector(sessionIdSelector);
    const location = useLocation();
    const isServiceNavExtern = location.pathname.includes("servicenavigatorExtern")
   
    const redirectResolved = useRedirectCheck();

    useEffect(() => {
        if (!sessionId) dispatch(setNewSessionId());
    }, [dispatch, sessionId]);

    return (
        <>
            <Anchor href="#skip_header" className="skip-link" aria-label="Zum Hauptinhalt springen" tabIndex={0}>
                Zum Hauptinhalt springen
            </Anchor>
            { !isServiceNavExtern && 
                <>
                    <HeadMeta seoMetaDataResponse={seoMetaDataResponse} markenStandortResponse={markenStandortResponse} />
                    <Matomo /> 
                    <ReduxSuspense response={markenStandortResponse} fallback={null} error={null}>
                        <HeaderSelector />
                    </ReduxSuspense> 
                    <FloatingSidebar />
                </> 
            }
            <ReduxSuspense response={markenStandortResponse}>
                <main id='main_content'>
                    { redirectResolved && <Routes /> }
                    { !isServiceNavExtern && 
                            <SeoContainer />
                    }
                </main>
            </ReduxSuspense>
            { !isServiceNavExtern && 
                <>
                    <footer role="contentinfo"><Footer /></footer>
                </>  
            }
            {/* Global Side Effect Components  */}
            <Theme />
            <NoSSR>
                { !isServiceNavExtern && <ScrollToTop />}
                <OneTrust />
            </NoSSR> 
            <ToTop />
        </>
    );
}

export default Layout;
